import React from 'react';
import PropTypes from 'prop-types';
import Icon from "../icon/icon";
export var CLASSNAME = 'Icons-audio-player-next-lite';
export var ID = 'icon-audio-player-next-lite';
/* eslint-disable max-len */

export var SVGAudioPlayerNextLite = function SVGAudioPlayerNextLite() {
  return React.createElement("symbol", {
    id: ID,
    viewBox: "0 0 12 12"
  }, React.createElement("path", {
    id: "audio-player-next-lite-path",
    fillRule: "evenodd",
    d: "M9 1.5h3v9H9v-9zM0 12V0l7.5 6L0 12z"
  }));
};
/* eslint-disable max-len */

var AudioPlayerNextLite = function AudioPlayerNextLite(props) {
  return React.createElement(Icon, {
    id: ID,
    className: props.className ? "".concat(props.className, " ").concat(CLASSNAME) : CLASSNAME,
    onClick: props.onClick,
    svg: SVGAudioPlayerNextLite
  });
};

AudioPlayerNextLite.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func
};
export default AudioPlayerNextLite;